import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }

import { watch } from "vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsRichTextEditor from "@/components/GgmsRichTextEditor.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { stripHtml } from "@/shared/utils/helpers"


export default /*@__PURE__*/_defineComponent({
  __name: 'NoteComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

watch(
    () => [workflowStore.modelValue.event, workflowStore.modelValue.value],
    () => {
        workflowStore.areButtonDisabled = !stripHtml(workflowStore.modelValue as string)
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Attach a Note", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 pb-4" }, "Attach a note to the enrolled contact.", -1)),
    _createVNode(GgmsCheckBox, {
      modelValue: _unref(workflowStore).modelValue.event,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
      label: "Pin note",
      class: "pb-6"
    }, null, 8, ["modelValue"]),
    _createVNode(GgmsRichTextEditor, {
      modelValue: _unref(workflowStore).modelValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.value) = $event)),
      placeholder: "Write your note...."
    }, null, 8, ["modelValue"])
  ]))
}
}

})